import http from "../../shared/http"
import workflowApi from "../../shared/workflowApi"
import Vue from 'vue'

const projects = {
    state: {
        items: [],
        currentProject: null,
        currentWorkspace: localStorage.getItem("current_workspace_uuid"),
        info: null,
        workflows: [],
        workflowsLoaded: false,
        infoMessages: null
    },
    actions: {
        fetchProject({commit}, uuid) {
            return new Promise((resolve, reject) => {
                let sub = this.getters.project(uuid)
                if (sub) resolve(sub)

                http.get("/v1/project/" + uuid).then((resp) => {
                    commit('SET_PROJECT', resp.data)
                    resolve(resp.data)
                }).catch((error) => {
                    reject(error)
                })
            })    
        },

        fetchProjects({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.items.length > 0) {
                    return resolve(state.items)
                }

                http.get("/v1/project/list").then((resp) => {
                    commit('SET_PROJECTS', resp.data)
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        fetchProjectInfo({commit, state}) {
            return new Promise((resolve, reject) => {
                if (state.info !== null) {
                    resolve(state.info)
                }

                http.get("/v1/project/info").then((resp) => {
                    commit('SET_PROJECT_INFO', resp.data)
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        fetchWorkflows({commit, state}, options) {
            return new Promise((resolve, reject) => {
                const opts = options || {}
                const force = opts.force === true

                if (state.workflowsLoaded && !force) {
                    return resolve(state.workflows)
                }

                workflowApi.get("workflows").then((resp) => {
                    commit('SET_WORKFLOWS', resp.data)
                    commit('SET_WORKFLOWS_LOADED', true)
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        fetchInfoMessages({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/project/info-messages").then((resp) => {
                    commit('SET_INFO_MESSAGES', resp.data)
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    },
    mutations: {
        SET_PROJECTS (state, items) {
            state.items = items
        },

        REMOVE_PROJECT (state, uuid) {
            state.items = state.items.filter(i => i.uuid != uuid)
        },

        SET_WORKFLOWS (state, items) {
            state.workflows = items
        },

        SET_WORKFLOWS_LOADED (state, loaded) {
            state.workflowsLoaded = loaded
        },

        SET_PROJECT (state, item) {
            state.items.push(item)
        },

        SET_PROJECT_INFO (state, info) {
            state.info = info
        },

        UPDATE_PROJECTS (state, item) {
            state.items.forEach((e, i) => {
                if (e.uuid == item.uuid) {
                    state.items[i] = item
                }
            })
        },

        DELETE_WORKSPACE (state, workspace) {
            let project = state.items.find(i => {
                return i.uuid == workspace.project_uuid;
            })

            state.items = state.items.map(i => {
                if (i.uuid == project.uuid) {
                    i.workspaces = i.workspaces.filter(w => {
                        return w.uuid !== workspace.uuid
                    })
                }

                return i;
            })
        },

        PROJECT_ADD_USER (state, payload) {
            state.items.forEach((e) => {
                if (e.uuid == payload.uuid) {
                    e.users.push(payload.user)
                }
            })
        },


        PROJECT_DELETE_USER (state, uuid) {
            state.items.forEach((p, index) => {
                if (p.uuid == state.currentProject) {
                    let items = p.users.filter(i => {
                        return i.user_uuid != uuid
                    })
        
                    Vue.set(state.items[index], 'users', items)
                }  
            }) 
        },

        SET_CURRENT_PROJECT(state, project) {
            Vue.set(state, "currentProject", project.uuid)
        },

        SET_CURRENT_WORKSPACE(state, workspace) {
            localStorage.setItem("current_workspace_uuid", workspace.uuid)
            Vue.set(state, "currentWorkspace", workspace.uuid)
        },

        SET_INFO_MESSAGES(state, messages) {
            state.infoMessages = messages
        },

        DELETE_WORKFLOW(state, id) {
            state.workflows = state.workflows.filter(w => w.uuid != id)
            state.workflowsLoaded = true
        }
    },
    getters: {
        projects(state) {
            return state.items
        },

        project: (state) => (uuid) => {
            return state.items.find((e) => {
                return e.uuid == uuid
            })
        },

        getWorkflows: state => {
            return state.workflows
        },
    
        getCurrentProject(state, getters) {
            const claims = getters.getClaims
            return state.items.find(i => {
                return i.uuid == claims.ProjectUUID
            })
        },

        getCurrentWorkspace(state, getters) {
            const workspaces = getters.getCurrentProject.workspaces || []
            return workspaces.find(w => {
                return w.uuid == state.currentWorkspace
            })
        },

        getAccount(state, getters) {
            return getters.getCurrentProject.account
        },

        getInfoMessages(state) {
            return state.infoMessages
        },

        getProjectInfo(state) {
            return state.info
        }
    }
  }

export default projects